var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{style:({ backgroundColor: _vm.whiteBg ? 'white' : 'initial' }),attrs:{"id":"sequence-player"}},[_c('img',{key:_vm.frameIdx,attrs:{"src":_vm.source}})])
}
var staticRenderFns = []

export { render, staticRenderFns }